import React from 'react';
import { Select } from 'antd';
import { useState } from 'react';
import PlotContainer from '../PlotContainer';
import { useGetLtrLtvQuery } from '../../redux/api/customerAnalytics';
import { useSelector } from 'react-redux';
import '../containerStyles.css';
import TooltipContainer from '../../components/UI/TooltipContainer';

const LifetimeRevenue = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);

    const [ltrLtvType, setLtrLtvType] = useState('ltr');
    const [filterType, setFilterType] = useState('All');

    return (
      <div className="main-content-container">
        <div className="flexible-container flex-row">
          <div>
            <h2>
              LTR Vs. LTV{" "}
              <TooltipContainer title="LTR Vs. LTV"></TooltipContainer>
            </h2>
            <Select
              style={{
                width: "10vw",
              }}
              options={[
                { label: "LTR", value: "ltr" },
                { label: "LTV", value: "ltv" },
                {
                  label: "LTV Without Shipping Cost",
                  value: "ltv_without_shipping_cost",
                },
              ]}
              onChange={(value) => {
                setLtrLtvType(value);
              }}
              value={ltrLtvType}
            ></Select>
          </div>
          <div>
            <h2>
              Filter By <TooltipContainer title="Filter By"></TooltipContainer>
            </h2>
            <Select
              style={{
                width: "10vw",
              }}
              options={[
                { label: "All", value: "All" },
                { label: "OTP", value: "OTP" },
                { label: "Subscription", value: "Subscription" },
              ]}
              onChange={(value) => {
                setFilterType(value);
              }}
              value={filterType}
            ></Select>
          </div>
        </div>
        <div
          style={{
            width: "95%",
            minWidth: "60vw",
            height: "170vh",
          }}
        >
          <PlotContainer
            tooltipTitle="Lifetime Revenue"
            useApi={useGetLtrLtvQuery}
            useApiArgs={{
              client: selectedClient,
              ltrLtvType: ltrLtvType,
              filterType: filterType,
            }}
          />
        </div>
      </div>
    );
};

export default LifetimeRevenue;